import React, { useEffect } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

const PrivateRoute = () => {
  const auth = useAuth();

  useEffect(() => {
    //console.log('checar');
    auth.checkAuth();
  }, [auth])
  
  return (
    <>
      {auth.isAuthenticated ? (
        <Outlet />
      ) : (
        <Navigate to="/login" />
      )}
    </>
  );
};

export default PrivateRoute;
